import { render, staticRenderFns } from "./Sidenav.html?vue&type=template&id=3d527656&scoped=true&external"
import script from "./Sidenav.vue?vue&type=script&lang=js"
export * from "./Sidenav.vue?vue&type=script&lang=js"
import style0 from "./Sidenav.less?vue&type=style&index=0&id=3d527656&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d527656",
  null
  
)

export default component.exports